import { render, staticRenderFns } from "./emptyBunkersOnTable.vue?vue&type=template&id=341547e1"
import script from "./emptyBunkersOnTable.vue?vue&type=script&lang=js"
export * from "./emptyBunkersOnTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports